import initializer from './initializer';
import handler from './handler';

import { chain } from '../utils';

export default chain(initializer, handler);
